// import styled from "styled-components";

// export const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 234px;
//   height: calc(100vh - 40px);
//   background: #2c2a34;
//   box-sizing: border-box;
//   border-right: 1px solid #555;
// `;

// export const LogoArea = styled.div`
//   margin-bottom: 10px;
//   padding: 12px 0;
//   text-align: center;
//   border-bottom: 1px solid #484654;
// `;

// export const LogoAreaTag = styled.a`
//   display: inline-block;
//   min-width: 50px;
//   padding: 10px 14px;
//   border-radius: 900px;
//   font-size: 0;
//   background: #fff;
//   cursor: pointer;
//   &::before {
//     display: inline-block;
//     content: "";
//     width: 0;
//     height: 100%;
//     vertical-align: middle;
//   }
// `;

// export const LogoH1 = styled.h1`
//   display: inline-block;
//   margin: 0;
//   font-size: 0;
//   vertical-align: middle;
//   width: 42px;
//   height: 22px;
// `;

// export const UlBox = styled.ul`
//   border-bottom: 1px solid #434149;
//   padding-bottom: 10px;
//   margin-bottom: 0;
//   width: 234px;
//   margin: 3px 0 5px 0;
//   list-style: none;
// `;

// export const Li = styled.li`
//   position: relative;
//   // margin: 5px 0px 5px 0px;
// `;

// export const UlATag = styled.a`
//   min-width: 156px;
//   display: flex;
//   align-items: center;
//   min-height: 33px;
//   color: #bdbcbe;
//   gap: 10px;
//   //   padding-left: 30px;
//   font-weight: normal;
//   font-size: 13px;
//   text-decoration: none;
// `;

// export const ClickBox = styled.div`
//   positon: relative;
//   padding: 0px 15px;
//   margin: 5px 0px;
//   font-weight: 700;
//   font-size: 13px;
//   color: #ccc;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// `;

// export const EmptyDiv = styled.div``;

// export const ButtonWrapper = styled.div`
//   padding: 1rem;
//   border: 1px solid #e5e7eb;
//   border-radius: 0.375rem;
// `;

// const StyledButton = styled.button`
//   align-items: center;
//   background-image: linear-gradient(144deg, #af40ff, #5b42f3 50%, #00ddeb);
//   border: 0;
//   border-radius: 8px;
//   box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
//   box-sizing: border-box;
//   color: #ffffff;
//   display: flex;
//   font-family: Phantomsans, sans-serif;
//   font-size: 20px;
//   justify-content: center;
//   line-height: 0.8em;
//   max-width: 100%;
//   min-width: 140px;
//   padding: 3px;
//   text-decoration: none;
//   user-select: none;
//   -webkit-user-select: none;
//   touch-action: manipulation;
//   white-space: nowrap;
//   cursor: pointer;

//   &:active,
//   &:hover {
//     outline: 0;
//   }

//   @media (min-width: 768px) {
//     font-size: 24px;
//     min-width: 196px;
//   }
// `;

// const ButtonSpan = styled.span`
//   background-color: rgb(5, 6, 45);
//   padding: 8px 16px;
//   border-radius: 6px;
//   width: 100%;
//   height: 100%;
//   transition: 300ms;
//   font-size: 1.4rem;
//   ${StyledButton}:hover & {
//     background: none;
//   }
// `;

// export const GanttButton = ({ children, ...props }) => {
//   return (
//     <StyledButton {...props}>
//       <ButtonSpan>{children}</ButtonSpan>
//     </StyledButton>
//   );
// };

import styled from "styled-components";

// export const Container = styled.div`
//   display: flex;
//   height: 100vh;
// `;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 11rem;
  // background-color: #0072c6;
  color: white !important;
  padding: 1rem 0 2rem 0;
  transition: all 0.5s ease;
  background: #000428;
`;

export const NavContainer = styled.nav`
  display: flex;
  flex-direction: column;
  space-between: 1.5rem;
  text-align: center;
  width: 80%;
`;

export const NavLink = styled.div`
  font-size: 1.125rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
  color: white !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Container = styled.div`
  width: 100vw;
  height: calc(100vh - 100px);
  display: flex;
  box-sizing: border-box;
  background-color: #e1e3ea;
  justify-content: center;
  position: fixed;
  top: 120px;
  right: 0;
  left: 0;
  // padding: 0 10%;
  gap: 1.6rem;
`;

export const ContainerViewer = styled.div`
  height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: center;
`;

export const Section = styled.div`
  // flex: ${(props) => props.$flex || 1};
  width: 1100px;
  position: relative;
  height: 100%;
`;

export const SectionContent = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border: 1px solid rgb(var(--mui-mainColorChannels-light) / 0.12);
  margin-top: 1.5rem;
`;

export const SectionText = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #374151;
  width: 100%;
  text-align: left;
  margin-left: 30%;
`;

export const BlurrySeparator = styled.div`
  width: 1px;
  background: linear-gradient(to bottom, transparent, #d1d5db, transparent);
  backdrop-filter: blur(4px);
`;

export const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--mui-palette-divider);
  z-index: 10;
`;

export const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

export const ToolbarRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
`;
